import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PlaceDraft {
  id: string;
  name: string;
  location: {
    lat: number | string;
    lng: number | string;
  };
  address: string;
  description: string;
  categories: string[];
  tags: string[];
  social: { key: string; value: string }[];
  owner_details: {
    name: string;
    email: string;
    phone: string;
    whatsapp: string;
  };
  imagesData: any[];
  createdAt: string;
  updatedAt: string;
}

interface PlaceDraftState {
  drafts: PlaceDraft[];
}

const initialState: PlaceDraftState = {
  drafts: [],
};

const PlaceDraftSlice = createSlice({
  name: 'placeDraft',
  initialState,
  reducers: {
    savePlaceDraft: (state, action: PayloadAction<Omit<PlaceDraft, 'id' | 'createdAt' | 'updatedAt'>>) => {
      const newDraft: PlaceDraft = {
        ...action.payload,
        id: Date.now().toString(),
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      };
      state.drafts.push(newDraft);
    },
    updatePlaceDraft: (state, action: PayloadAction<{ id: string; draft: Partial<PlaceDraft> }>) => {
      const { id, draft } = action.payload;
      const draftIndex = state.drafts.findIndex(d => d.id === id);
      if (draftIndex !== -1) {
        state.drafts[draftIndex] = {
          ...state.drafts[draftIndex],
          ...draft,
          id, // Ensure ID doesn't change
          updatedAt: new Date().toISOString(),
        };
      }
    },
    deletePlaceDraft: (state, action: PayloadAction<string>) => {
      state.drafts = state.drafts.filter(draft => draft.id !== action.payload);
    },
    clearAllPlaceDrafts: (state) => {
      state.drafts = [];
    },
    setPlaceDrafts: (state, action: PayloadAction<PlaceDraft[]>) => {
      state.drafts = action.payload;
    },
  },
});

export const { 
  savePlaceDraft, 
  updatePlaceDraft, 
  deletePlaceDraft, 
  clearAllPlaceDrafts, 
  setPlaceDrafts 
} = PlaceDraftSlice.actions;
export default PlaceDraftSlice.reducer;
